const eProductType = {
  survey: 1,
  genetic: 2,
  lifeStyle: 3,
  prediabetes: 4
};

export default eProductType;
